import React from 'react';
import QuestionBody from "./QuestionBody";
import axios from 'axios';
import ReactDOM from 'react-dom'
import $ from "jquery";
import {config} from "../../constants/Constants";
var striptags = require('striptags');



class Questions extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            qArr:[],
            additionalArr:[],
            possibleAnswersArr:'',
            additionalAnswerArr:'',
            selectedOption:'',
            resultArr:[],
            resultKey:'',
            additionalResultArr:[],
            additionalResultKey:'',
            answerGivenArr:[],
            additionalAnswerGivenArr:[],
            dragDropOptions:[],
            dragDropOptionsTitle:[],
            gapAnswerOptions:[],
            correctAns:'',
            additionalCorrectAns:this.props.question.field_correct_answer_additional,
            correctOption:'',
            classes:[],
            score:[],
            type: this.props.question.field_question_type,
            multiple: this.props.question.field_multiple_questions,
            correctResults:[],
            additionalCorrectResults:[],

        }
        let res=[];

        this.setResult = this.setResult.bind(this)
        this.setAdditionalResult = this.setAdditionalResult.bind(this)
        /*this.questionBody = React.createRef();*/
       /* this.setRef = this.setRef.bind(this);*/
    }

    _compareArr(x,y){
        let arraysAreSame = 0;
        for(var propertyName in x) {
            if(x[propertyName] !== y[propertyName]) {
                arraysAreSame += 1;
            }
        }

        return arraysAreSame;
    }

    componentDidMount() {
        this.setState({score:{0:0,1:0,2:0}})

        /*let result = {
            question:'question',
            answer:'answer',
        }
        this._saveResults(result)*/
    }
    _updateMCPossibleAnsArr(options){
        let possibleAnswersArr = [];
        let op = []
        op.push([1,options[0]+options[1]])
        op.push([2,options[2]+options[3]])
        op.push([3,options[4]+options[5]])
        op.map((option,key)=>{
            if(option[0]==1){
                /*possibleAnswersArr.push(option[1]);*/
                this.setState({possibleAnswersArr: option[1]});
            }
        });

    }
    _updateAdditionalMCPossibleAnsArr(options){
        let additionalAnswerArr = [];
        let op = []
        op.push([1,options[0]+options[1]])
        op.push([2,options[2]+options[3]])
        op.push([3,options[4]+options[5]])
        op.map((option,key)=>{
            if(option[0]==2){
                /*additionalAnswerArr.push(option[1]);*/
                this.setState({additionalAnswerArr: option[1]});
            }
        });

    }
    _updateGapResultArr(gapAnswerOptions){
        this.setState({gapAnswerOptions: []});
       /* console.log(gapAnswerOptions)*/
        if(gapAnswerOptions != ""){
            let gapOptions = this.state.gapAnswerOptions.slice();
            gapAnswerOptions.map(op=>{
                gapOptions.push(op);
            })

            this.setState({gapAnswerOptions: gapOptions});
        }
    }
    _updateDnDResultArr(dragDropAnswerOptions,dragDropAnswerOptionsTitle){
        if(dragDropAnswerOptions!=""){
            let dragDropOptions = this.state.dragDropOptions.slice();
            dragDropAnswerOptions.map(op=>{
                dragDropOptions.push(op);
            })

            this.setState({dragDropOptions: dragDropOptions});

            let dragDropOptionsTitle = this.state.dragDropOptionsTitle.slice();
            dragDropAnswerOptionsTitle.map(op=>{
                dragDropOptionsTitle.push(op);
            })
            /* dragDropOptionsTitle.push(dragDropAnswerOptionsTitle);*/
            this.setState({dragDropOptionsTitle: dragDropOptionsTitle});
        }
    }

    _updateResultArr(){
        let answerGivenArr = this.state.answerGivenArr.slice();
        answerGivenArr.push(this.state.resultArr);
        this.setState({answerGivenArr: answerGivenArr});


        let additionalAnswerGivenArr = this.state.additionalAnswerGivenArr.slice();
        additionalAnswerGivenArr.push(this.state.additionalResultArr);
        this.setState({additionalAnswerGivenArr: additionalAnswerGivenArr});

       /* if(dragDropAnswerOptions!="" ) {
            /!*this._checkDnDAnswer();*!/
        }else if(gapAnswerOptions!=""){
            /!*this._checkGapAnswer();*!/
        }else{*/
           /* if (this.state.multiple == "1") {
                this._checkAdditionalAnswer()
            } else {
                this._checkAnswer();
            }*/
       /* }*/
    }
    _checkGapAnswer(){
        /*console.log(this.state.gapAnswerOptions)
        console.log(this.state.possibleAnswersArr)*/
        let errorsCount = this._compareArr(this.state.gapAnswerOptions,this.state.possibleAnswersArr);
        errorsCount=parseInt(errorsCount);

       /* console.log(errorsCount)*/
        if(errorsCount == 0) {
           /* console.log('correct GAP')*/
            this.setState({correctOption:true})
            let classes = this.state.classes.slice();
            classes.push("#e5ffbf");
            this.setState({classes: classes});
        } else {
           /* console.log('incorrect GAP')*/
            this.setState({correctOption: false})
            if (this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + errorsCount;
                this.setState({score: {0: points, 1: this.state.score[1], 2: this.state.score[2]}})
            } else if (this.state.type == "1") {
                let points = parseInt(this.state.score[1]) + errorsCount;
                this.setState({score: {0: this.state.score[0], 1: points, 2: this.state.score[2]}})
            } else {
                let points = parseInt(this.state.score[2]) + errorsCount;
                this.setState({score: {0: this.state.score[0], 1: this.state.score[1], 2: points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }
    }
    _checkMCAnswer(){
        if(this.state.resultKey == "1" && this.state.additionalResultKey == "2"){
            /*console.log('correct MC')*/
            this.setState({correctOption:true})
            let classes = this.state.classes.slice();
            classes.push("#e5ffbf");
            this.setState({classes: classes});

        }else if((this.state.resultKey == "1" && this.state.additionalResultKey != "2") ||
            (this.state.resultKey != "1" && this.state.additionalResultKey == "2")){
            /*console.log('hi half pass MC')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + 1;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + 1;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + 1;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }else{
            /* console.log('hi full fail MC')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + 2;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + 2;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + 2;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }

    }
    _checkDnDAnswer(){
        let dnDArr = [];
        this.state.dragDropOptions.map((option, key) => {
            let id = parseInt(option);
            dnDArr.push(id);

        });
        let errorsCount = this._compareArr(dnDArr,this.state.correctAns)
        errorsCount=parseInt(errorsCount);

       /* console.log(errorsCount)*/
        if(errorsCount == 0) {
           /* console.log('correct DND')*/
            this.setState({correctOption:true})
            let classes = this.state.classes.slice();
            classes.push("#e5ffbf");
            this.setState({classes: classes});
        } else {
           /* console.log('incorrect DND ans')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + errorsCount;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + errorsCount;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + errorsCount;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }

    }
    _checkAnswer(){
        if(this.state.resultKey == this.state.correctAns){
            /*console.log('correct')*/
            this.setState({correctOption:true})
            let classes = this.state.classes.slice();
            classes.push("#e5ffbf");
            this.setState({classes: classes});
        }else{
           /* console.log('incorrect')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + 1;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + 1;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + 1;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }

      /*  console.log(this.props.question)*/
      /*  this.setState({type:this.props.question.field_question_type})
        this.setState({multiple:this.props.question.field_multiple_questions})
        this.setState({correctAns:this.props.question.field_correct_answer})
        this.setState({additionalCorrectAns:this.props.question.field_correct_answer_additional})*/
    }

    _checkAdditionalAnswer(){
        if(this.state.resultKey == this.state.correctAns && this.state.additionalResultKey == this.state.additionalCorrectAns){
            /*console.log('correct')*/
            this.setState({correctOption:true})
            let classes = this.state.classes.slice();
            classes.push("#e5ffbf");
            this.setState({classes: classes});

        }else if((this.state.resultKey == this.state.correctAns && this.state.additionalResultKey != this.state.additionalCorrectAns) ||
            (this.state.resultKey != this.state.correctAns && this.state.additionalResultKey == this.state.additionalCorrectAns)  ){
          /*  console.log('hi half pass')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + 1;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + 1;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + 1;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});

        }else{
            /*console.log('hi full fail')*/
            this.setState({correctOption:false})
            if(this.state.type == "0") {
                let points = parseInt(this.state.score[0]) + 2;
                this.setState({score:{0:points,1:this.state.score[1],2:this.state.score[2]}})
            }else if(this.state.type == "1"){
                let points = parseInt(this.state.score[1]) + 2;
                this.setState({score:{0:this.state.score[0],1:points,2:this.state.score[2]}})
            }else{
                let points = parseInt(this.state.score[2]) + 2;
                this.setState({score:{0:this.state.score[0],1:this.state.score[1],2:points}})
            }
            let classes = this.state.classes.slice();
            classes.push("#fbe3e4");
            this.setState({classes: classes});
        }

       /* console.log(this.props.question)*/
       /* this.setState({type:this.props.question.field_question_type})
        this.setState({multiple:this.props.question.field_multiple_questions})
        this.setState({correctAns:this.props.question.field_correct_answer})
        this.setState({additionalCorrectAns:this.props.question.field_correct_answer_additional})*/
    }
    _updateAdditionalAnswerArr(possibleAnswers,correctAnswer){
        let additionalAnswerArr = [];
        possibleAnswers.map((option, key) => {
            let id = parseInt(key) + 1;
            if (option[0] == parseInt(correctAnswer)) {
              /*  additionalAnswerArr.push(option);*/
                this.setState({additionalAnswerArr: option[1]});

            }
        });

    }
    _updatePossibleAnswerArr(possibleAnswers,correctAnswer){
       /* let possibleAnswersArr = this.state.possibleAnswersArr.slice();*/
        if(correctAnswer!="") {
            possibleAnswers.map((option, key) => {
                let id = parseInt(key) + 1;
                if (option[0] == parseInt(correctAnswer)) {
                    /*possibleAnswersArr.push(option);*/
                    this.setState({possibleAnswersArr: option[1]});
                }
            });
        }else{
            /*possibleAnswersArr.push("");*/
            this.setState({possibleAnswersArr: ""});
        }
    }
    _updateCorrectResultArr(main){
        let correctResults = this.state.correctResults.slice();
        if(main!="") {
            correctResults.push(this.state.possibleAnswersArr);
        }else{
            correctResults.push("");
        }
        this.setState({correctResults: correctResults});

    }
    _updateAdditionalCorrectResultArr(additional){
        let additionalCorrectResults = this.state.additionalCorrectResults.slice();
        if(additional!="") {
            additionalCorrectResults.push(this.state.additionalAnswerArr);
        }else{
            additionalCorrectResults.push("");
        }
        this.setState({additionalCorrectResults: additionalCorrectResults});

    }
    _updateDnDPossibleAnswerArr(possibleAnswers){
        let possibleAnswersArr = [];
        possibleAnswers.map((option, key) => {
            let id = parseInt(key) + 1;
            let op = [option[0],option[1]];
            possibleAnswersArr.push(op);

        });
        /*possibleAnswersArr = this._shuffle(possibleAnswersArr)*/
        this.setState({possibleAnswersArr: possibleAnswersArr});
    }
    _updateGapPossibleAnswerArr(possibleAnswers){
        let possibleAnswersArr = [];
        possibleAnswers.map((option, key) => {
            /*let id = parseInt(key) + 1;
            let op = [id,option];*/
            let strippedOption = striptags(option).toString();
            strippedOption =strippedOption.trim()
            possibleAnswersArr.push(strippedOption);

        });
       /* possibleAnswersArr = this._shuffle(possibleAnswersArr)*/
        this.setState({possibleAnswersArr: possibleAnswersArr});
    }
    _updateQuestionDnDArr(question){

        let q = question.toString();
        let correct=[];
        this.state.dragDropOptionsTitle.map((title,i)=>{
            if(this.state.dragDropOptions[i]==this.state.correctAns[i]){
                q=q.replace("SELECT","<b>"+title+"</b>")
                correct.push("")
            }else{

                this.state.possibleAnswersArr.map((option,k)=>{
                    if(this.state.possibleAnswersArr[k][0] == this.state.correctAns[i]) {
                        correct.push(this.state.possibleAnswersArr[k][1].replace(/(<([^>]+)>)/ig, ""));
                    }
                })
                q = q.replace("SELECT",
                    "<b>" + correct[i] + "</b> <span style='text-decoration: line-through'>" + this.state.dragDropOptionsTitle[i] + "</span>");
            }
        })

        let questionArr = this.state.qArr.slice();
        if(q!="") {
            questionArr.push(q);
            this.setState({qArr: questionArr});
        }else{
            questionArr.push("");
            this.setState({qArr: questionArr});
        }

    }
    _updateQuestionGapArr(question){

        let q = question.toString();
        let correct=[];
        this.state.gapAnswerOptions.map((title,i)=>{
            if(this.state.gapAnswerOptions[i]==this.state.possibleAnswersArr[i]){
                q=q.replace("TYPE","<b>"+title+"</b>")
                /*correct.push("")*/
            }else{

                if(this.state.gapAnswerOptions[i] == "") {
                    this.state.gapAnswerOptions[i] = "nichts";
                }
                q = q.replace("TYPE",
                    "<b>" + this.state.possibleAnswersArr[i] + "</b> <span style='text-decoration: line-through'>" + this.state.gapAnswerOptions[i] + "</span>");
            }
        })
        let questionArr = this.state.qArr.slice();
        if(q!="") {
            questionArr.push(q);
            this.setState({qArr: questionArr});
        }else{
            questionArr.push("");
            this.setState({qArr: questionArr});
        }

    }
    _updateQuestionArr(question){
        let questionArr = this.state.qArr.slice();
        if(question!="") {
            questionArr.push(question);
            this.setState({qArr: questionArr});
        }else{
            questionArr.push("");
            this.setState({qArr: questionArr});
        }
    }
    _updateAdditionalQuestionArr(additionalQuestion){
        let additionalQuestionArr = this.state.additionalArr.slice();
        if(additionalQuestion != "") {
            additionalQuestionArr.push(additionalQuestion);
            this.setState({additionalArr: additionalQuestionArr});
        }else{
            additionalQuestionArr.push("");
            this.setState({additionalArr: additionalQuestionArr});
        }
    }
    _updateCorrectAnswerArr(correctAnswer){
        this.setState({correctAns: parseInt(correctAnswer)});
    }
    _updateDnDCorrectAnswerArr(possibleAnswers){
        let possibleAnswersArr = [];
        possibleAnswers.map((option, key) => {
            let id = parseInt(key) + 1;
            possibleAnswersArr.push(id);

        });
        this.setState({correctAns: possibleAnswersArr});
    }
    _updateGapCorrectAnswerArr(possibleAnswers){
        let possibleAnswersArr = [];
        possibleAnswers.map((option, key) => {
            let id = parseInt(key) + 1;
            possibleAnswersArr.push(id);

        });
        this.setState({correctAns: possibleAnswersArr});
    }
    _updateType(type){
        this.setState({type: type});
    }
    _updateMultipleQ(multipleQ){
        this.setState({multiple: multipleQ});
    }
    _updateAdditionalCorrectAnswerArr(additionalCorrectAnswer){
        this.setState({additionalCorrectAns: parseInt(additionalCorrectAnswer)});
    }

    _updateArr(question,possibleAnswers,correctAnswer,type){

      /*  console.log(question);*/
        setTimeout(()=>{
            this._updateQuestionArr(question);
            this._updateAdditionalQuestionArr("");
            this._updateCorrectAnswerArr(correctAnswer)
            this._updateType(type);
            this._updateMultipleQ("")
            this._updatePossibleAnswerArr(possibleAnswers,correctAnswer);
            this._updateCorrectResultArr("main");
            this._updateAdditionalCorrectResultArr("");
            this._updateResultArr();
            this._checkAnswer();

        },100)
       /* console.log(this.props.question)*/
    }
    _updateMQArr(param){
        setTimeout(()=>{
            this._updateQuestionArr(param[0]);
            this._updateAdditionalQuestionArr(param[2]);
            this._updateCorrectAnswerArr(param[4]);
            this._updateType(param[6]);
            this._updateMultipleQ(param[7])
            this._updatePossibleAnswerArr(param[1],param[4]);
            this._updateAdditionalAnswerArr(param[3],param[5]);
            this._updateAdditionalCorrectAnswerArr(param[5]);
            this._updateCorrectResultArr("main");
            this._updateAdditionalCorrectResultArr("additional");
            this._updateResultArr();
            this._checkAdditionalAnswer();
        },100)
    }

    _updateDnDArr(param){
        setTimeout(()=>{
            this._updateDnDPossibleAnswerArr(param[1])
            this._updateDnDCorrectAnswerArr(param[1])
            this._updateType(param[4]);
            this._updateMultipleQ(param[5])
            this._updateCorrectResultArr("");
            this._updateAdditionalCorrectResultArr("");
            this._updateResultArr();
            this._updateDnDResultArr(param[2],param[3]);
            this._updateQuestionDnDArr(param[0]);
            this._updateAdditionalQuestionArr("");
            this._checkDnDAnswer();

        },100)
    }

    _updateGapArr(param){
        /*console.log(param)*/
        setTimeout(()=>{
            this._updateGapPossibleAnswerArr(param[1]);
           /* this._updateGapCorrectAnswerArr(param[1])*/
            this._updateType(param[4]);
            this._updateMultipleQ(param[5])
            this._updateCorrectResultArr("");
            this._updateAdditionalCorrectResultArr("");
             this._updateResultArr();
             this._updateGapResultArr(param[2]);
            this._updateQuestionGapArr(param[0]);
            this._updateAdditionalQuestionArr("");
            this._checkGapAnswer();
        },100)
    }


    _updateMCArr(param){
        setTimeout(()=>{
            this._updateQuestionArr(param[0]);
            this._updateAdditionalQuestionArr(param[2]);
            this._updateType(param[6]);
            this._updateMultipleQ(param[7])
            this._updateMCPossibleAnsArr(param[1]);
            this._updateAdditionalMCPossibleAnsArr(param[1]);
            this._updateCorrectResultArr("main");
            this._updateAdditionalCorrectResultArr("additional");
            this._updateResultArr();
            this._checkMCAnswer();
        },100)
    }


    _getAllResults(){
       /* console.log(this.state.qArr);*/
        let testResult=[];
        testResult.push(this.state.qArr)
        testResult.push(this.state.answerGivenArr)
        testResult.push(this.state.correctResults)
        testResult.push(this.state.additionalArr)
        testResult.push(this.state.additionalAnswerGivenArr)
        testResult.push(this.state.additionalCorrectResults)
        testResult.push(this.state.classes)
        this._saveResults(testResult)
    }
    _saveResults(results){
      /*  console.log('save results')
        console.log(this.props.language,this.state.score[0],this.state.score[1],this.state.score[2],results)*/

     /* console.log(this.props.paramFrame);*/
        let frameAvail = this.props.paramFrame;
        let pData = this.props.paramData;
        let restUrl,redirectUrl;
        let homeurl = config.url.API_URL;
        if(process.env.NODE_ENV === "development"){
            //restUrl = homeurl+'sprachtest/upload/result/db?_format=json';
            restUrl = homeurl+'sprachtest/upload/result/db';
            if(pData!="" && Object.keys(pData).length>0){
                redirectUrl = homeurl+ "node/add/result?pid="+pData.pid+"&gid="+pData.gid+"&auth_id="+pData.authid+"&rowid=";
            }else if(frameAvail!="" && Object.keys(frameAvail).length){
                //redirectUrl =  homeurl+"node/add/result?version="+frameAvail.version+"&rowid=";
                redirectUrl =  homeurl+"node/add/result?version="+frameAvail.version+"&footer="+frameAvail.footer+"&brand="+frameAvail.brand+"&rowid=";
            }else{
                redirectUrl = homeurl+ "node/add/result?rowid=";
            }
        }else{
            //restUrl = '/sprachtest/upload/result/db?_format=json';
            restUrl = '/sprachtest/upload/result/db';
            if(pData!="" && Object.keys(pData).length){
                redirectUrl =  "node/add/result?pid="+pData.pid+"&gid="+pData.gid+"&auth_id="+pData.authid+"&rowid=";
            }else if(frameAvail!="" && Object.keys(frameAvail).length){
                //redirectUrl =  "node/add/result?version="+frameAvail.version+"&rowid=";
                redirectUrl =  "node/add/result?version="+frameAvail.version+"&footer="+frameAvail.footer+"&brand="+frameAvail.brand+"&rowid=";
            }else{
                redirectUrl =  "node/add/result?rowid=";
            }

        }

       /* let el = document.getElementById("sprachtest_csrf_token").innerHTML;
        let token = '';
        if (el) {
            token = el;
        }
        console.log(token);
        console.log(basic);*/
        axios.post(restUrl,
            {
                language: this.props.language,
                reading: this.state.score[0],
                listening: this.state.score[1],
                grammar: this.state.score[2],
                results: JSON.stringify(results),
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=UTF-8',
                    /*'Authorization': basic,
                    common: {
                        'X-CSRF-Token': token
                    }*/
                },
            })
            .then(function (response) {
                let rowid = response.data;
                window.location.href = redirectUrl +rowid;
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    setResult(resultArr,resultKey,resultGroup){
         if(this.props.question.field_drag_drop=="1"){
             this.setState({resultArr:''})
             setTimeout(()=> {
                 if($("input.dragDrop").last().val() != ""){
                     this.props.setDisabled(false,true)
                 }
             },100);
         }else  if(this.props.question.field_gap_question=="1"){
             this.setState({resultArr:''})
             if($("input.gap").last().val() != ""){
                 this.props.setDisabled(false,true)
             }
         }else if((this.props.question.field_multiple_questions=="1") ||
             (this.props.question.field_multiple_choice_ques=="1")){
             this.setState({resultArr: resultArr})
             this.setState({resultKey: parseInt(resultKey)})
             let e = document.getElementsByClassName('col-options3');
             for (let i = 0; i < e.length; i++) {
                 if(e[i].hasAttribute('checked')){
                     this.props.setDisabled(false,true)
                 }
             }
         }
         else {
             this.setState({resultArr: resultArr})
             this.setState({resultKey: parseInt(resultKey)})
             if(this.props.question.field_multiple_questions!="1" &&
                 this.props.question.field_multiple_choice_ques!="1"){
                 this.props.setDisabled(false,true)
             }
         }
    }
    setAdditionalResult(additionalResultArr,additionalResultKey){
        if(this.props.question.field_drag_drop=="1"){
            this.setState({additionalResultArr:''})
        }else if(this.props.question.field_gap_question=="1"){
            this.setState({additionalResultArr:''})
        }else {
            this.setState({additionalResultArr: additionalResultArr})
            this.setState({additionalResultKey: parseInt(additionalResultKey)})
            let e = document.getElementsByClassName('col-options2');
            for (let i = 0; i < e.length; i++) {
                if(e[i].hasAttribute('checked')){
                    this.props.setDisabled(false,true)
                }
            }

        }

    }

    render(){

       /* console.log(this.state.qArr)*/
        /*console.log(this.props.paramData)*/
       /* console.log(this.state.score)*/
       /* console.log(this.state.dragDropOptions)*/
     /*   console.log(this.state.correctResults)
        console.log(this.state.additionalCorrectResults)*/
        /*console.log(this.state.additionalCorrectAns)*/
       /* console.log(this.state.resultArr)
        console.log(this.state.additionalResultArr)*/
       /* if(this.state.answerGivenArr.length>0) {
            console.log(this.state.answerGivenArr)
        }
        if(this.state.additionalAnswerGivenArr.length>0) {
            console.log(this.state.additionalAnswerGivenArr)
        }*/
       /* console.log(this.state.additionalAnswerArr);*/
        /*console.log(this.props.question);*/
        /*console.log(this.state.qArr)*/
      /*  console.log(this.state.additionalArr)*/

      /*console.log(this.state.additionalArr);*/
        const question = this.props.question;
        const frageBody={
            questionTitle:question.field_question,
            questionType:question.field_question_type,
            options:question.field_answers,
        /*    options:this.props.mainOptions,*/
            correctAnswer:question.field_correct_answer,
            multipleQuestions:question.field_multiple_questions,
            additionalQuestion:question.field_additional_question,
            additionalAnswer:question.field_additional_answers,
          /*  additionalAnswer:this.props.additionalOptions,*/
            correctAnswerAdditional:question.field_correct_answer_additional,
            gapQuestion:question.field_gap_question,
            dragDropQuestion:question.field_drag_drop,
            multipleChoiceQues:question.field_multiple_choice_ques,
            matchQuestion:question.field_match_answer,
            getSelectedAnswer:this.props.getSelectedAnswer,
        };
       /* console.log(frageBody);*/
        return(
          <div className="frage">
              <div className="frage-body">
               {/* <QuestionBody frageBody={this.props}/>*/}
                <QuestionBody frageBody={frageBody}
                              setResult={this.setResult}
                              setAdditionalResult={this.setAdditionalResult}
                              /*setRef={this.setRef}*/
                              /*ref={this.questionBody}*/
                             /* updateSelctionResultArr={this._getResult} */ />
                 {/* <ul ref={input => {this.answerInput = input;}}>
                      <li selected={true} key="1">AB</li>
                      <li selected={false} key="2">DB</li>
                  </ul>*/}
              </div>
          </div>
        );
    }
}

export default Questions;
